<template>

  <header class="p-3 pt-5 pb-5 d-flex align-items-start justify-content-center">
    <div v-if="site == 'gn' && contact_KC && KC_available == false"
    
    @click="contact_KC = false"
    style="cursor: pointer; margin: 2px 10px 0 -20px">
    <i class="fa-regular fa-arrow-left fa-lg ms-2"></i>
    </div>
    <h5 class="text-center" style="text-transform:none;">{{ KC_available == true ? 'Chatta med oss' : 'Kontakta oss'}}</h5> 
  </header>

  <template v-if="site == 'gn'">
        <LiveChatWidget license="5661091" group="1" visible="minimized"></LiveChatWidget>
  
    <iframe id="mitelChat" style="position: absolute; top: 0; padding-bottom: 60px; z-index:1;" v-if="contact_KC == true && KC_available == true" height="100%"
    width="100%" frameBorder="0" :src="this.chatUrl"></iframe>
    <div class="h-100 overflow-auto" v-if="contact_KC == true && KC_available == false">
        <div class="w-100 h-100 position-relative pt-1" >
    
          <iframe style="position: absolute; top: 0; left: 0; right: 0; padding: 1rem 0 0 0;
          bottom: 0;"
            height="100%" width="100%" frameBorder="0"
            :src="'https://apps.gavleenergi.se/forms/kundservice/' + site + '/?type=' + this.type"></iframe>
    
        </div>
    </div>

    <div v-else class="d-flex flex-column text-center px-4 mt-5">
      <h3 class="h6 fw-bold">Vad behöver du hjälp med?</h3>
      <div>
        <p>Vår kundservice hjälper dig med frågor kring beställning av tjänster, dina avtal och fakturor.</p>
        <button class="btn btn-primary" @click="contact_KC = true">Kundservice</button>
      </div>

      <div class="mt-4">
        <p v-if="H1_available">Vår support hjälper dig som har problem med uppkopplingen och andra tekniska frågor som rör ditt bredband.</p>
          
        <p v-else>Chatten till vår tekniska support är offline. Testa vår <a href="https://gavlenet.se/kundservice/felanmalan/">supportguide</a> här eller mejla till <a href="mailto:support@gavlenet.com">support@gavlenet.com</a>.</p>
        
        <div>
          <button class="btn btn-primary" @click="showLiveChat()" :class="{'disabled' : !H1_available}">Teknisk support</button>
        </div>
  
      </div>
    </div>
  </template>
  <template v-else>

    <iframe id="mitelChat" style="position: absolute; top: 0; padding-bottom: 60px; z-index:1;" v-if="KC_available == true" height="100%"
    width="100%" frameBorder="0" :src="this.chatUrl"></iframe>

    <div class="h-100 overflow-auto" v-else>
      <div class="w-100 h-100 position-relative pt-1" >
  
        <iframe style="position: absolute; top: 0; left: 0; right: 0; padding: 1rem 0 0 0;
        bottom: 0;"
          height="100%" width="100%" frameBorder="0"
          :src="'https://apps.gavleenergi.se/forms/kundservice/' + site + '/?type=' + type"></iframe>
  
      </div>
  </div>
    
  </template>


  <ComponentStyles>
    #chat-widget-container {
    width: 400px !important;
    height: 632px !important;
    max-height: calc(100% - 182px) !important;
    bottom: 54px !important;
    right: 0 !important;
    display: none !important;
    }

    .lc-1alv3b0 {
    border-radius: 5px;
    }

    #chat-widget-container.visible {
    display: block !important;
    }

  </ComponentStyles>
</template>

<script>




import { LiveChatWidget, useWidgetState } from '@livechat/widget-vue'
import ComponentStyles from '../componentStyles.vue'

export default {
  components: { LiveChatWidget, ComponentStyles },
  props: { checkChatState: { type: Function }, site: { type: String }, hideFaq: {type: Function}, type: {type: String} },
  data() {
    let chatUrl;
    if (this.site == "gn") {
      chatUrl = `https://www.gavlenet.se/inc/mitel/?site=${this.site}`;
    } else {
      chatUrl = `https://apps.gavleenergi.se/mitel/?site=${this.site}`;
    }
    let contact_KC = false;
    if (this.site !== 'gn'){ contact_KC = true}

    return {
      chat: false,
      chatUrl,
      KC_available: false,
      H1_available: false,
      displayLiveChat: false,
      contact_KC,
      LCwidgetState: useWidgetState()
    }


  },

  watch: {


    LCwidgetState() {
      this.checkVisibility()
      console.log(this.LCwidgetState)
    },

    displayLiveChat(newValue) {
      const chatWidgetContainer = document.getElementById('chat-widget-container');
      if (chatWidgetContainer) {
        chatWidgetContainer.classList.toggle('visible', newValue);
      }
    },
  },

  methods: {


    showLiveChat() {
      window.LiveChatWidget.call("maximize")
      this.displayLiveChat = true;
    },

    checkVisibility() {
      const chatWidgetContainer = document.getElementById('chat-widget-container');
      if (this.LCwidgetState.visibility == 'maximized') {
        window.showFaqChat();
        this.displayLiveChat = true;
        if (chatWidgetContainer) {
          chatWidgetContainer.classList.add('visible');
        }
      } else if (this.LCwidgetState.visibility == 'minimized') {
        this.displayLiveChat = false;
        if (chatWidgetContainer) {
          chatWidgetContainer.classList.remove('visible');
        }
      }

      this.H1_available = this.LCwidgetState.availability === 'online';
    },

    checkWidgetState() {
      fetch("https://gavchat.uc.tele2.se/StatAPI/api/customerstat/statprovider?tenant=3&servicegrp=CTEnergi")
        .then(res => res.json())
        .then(json => {
          this.KC_available = json.Status.Availability == 1;
          this.checkChatState(this.KC_available);
        });
    }
  },



  mounted() {
    this.checkWidgetState();
    window.addEventListener('message', (event) => {
      if (event.data === 'mitelChatClosed') {

        this.site == "gn" ? this.contact_KC = false : this.hideFaq();
      }
    });


  },




}
</script>
  
<style scoped></style>
  